import { render, staticRenderFns } from "./projectDialog.vue?vue&type=template&id=19950bda&scoped=true"
import script from "./projectDialog.vue?vue&type=script&lang=js"
export * from "./projectDialog.vue?vue&type=script&lang=js"
import style0 from "./projectDialog.vue?vue&type=style&index=0&id=19950bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19950bda",
  null
  
)

export default component.exports